import React, { useEffect } from "react";
import { jwtDecode } from "jwt-decode";
import refresh from "./refresh";

export default function useRefresh() {
  const { refreshAPI } = refresh();

  const refreshTimeOut = (accessToken) => {
    const decoded = jwtDecode(accessToken);
    const exp = new Date(decoded?.token_expire_time);

    setTimeout(async () => {
      const res = await refreshAPI();
      const accessToken = res?.data?.access_token;
      localStorage.setItem("access_token", accessToken);
    }, exp - Date.now() - 10000);
  };

  return { refreshTimeOut };
}
